import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';

const testimonials = [
  {
    id: 1,
    name: '小明',
    content: 'YY漫画网资源太全了，韩漫日漫国漫都有，而且还是免费的！画质清晰，下拉式阅读体验很棒，追更也很及时。',
    rating: 5,
  },
  {
    id: 2,
    name: '星星',
    content: '作为一个漫画迷，我用了很多漫画网站，YY漫画网的分类做得最好，找漫画特别方便。排行榜推荐的漫画也都很好看！',
    rating: 5,
  },
  {
    id: 3,
    name: '微风',
    content: '最喜欢的免费漫画网站没有之一！更新速度快，很多热门漫画都能第一时间看到。下拉式阅读非常流畅，推荐给所有漫画爱好者。',
    rating: 5,
  },
  {
    id: 4,
    name: '阿杰',
    content: '偶然发现的漫画网站，用了一段时间真的很满意。漫画种类多，分类清晰，重点是全集漫画免费看，太良心了！',
    rating: 5,
  },
];

export default function About() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const aboutJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于 YY漫画网',
    description: 'YY漫画网品牌介绍、用户口碑和联系方式。YY漫画网提供韩漫、日漫、国漫等免费漫画在线阅读。',
    url: 'https://yymanhua.com/about',
    inLanguage: 'zh-CN',
    isPartOf: {
      '@type': 'WebSite',
      name: 'YY漫画网',
      url: 'https://yymanhua.com',
    },
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首页', item: 'https://yymanhua.com' },
        { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://yymanhua.com/about' },
      ],
    },
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      { '@type': 'Question', name: 'YY漫画网的漫画都是免费的吗？', acceptedAnswer: { '@type': 'Answer', text: '是的，YY漫画网所有漫画内容均为免费阅读，无需付费订阅，让每一位漫画爱好者都能自由畅享阅读乐趣。' } },
      { '@type': 'Question', name: '支持哪些类型的漫画？', acceptedAnswer: { '@type': 'Answer', text: '我们提供韩漫、日漫、国漫等多个分类，涵盖恋爱、热血、奇幻、搞笑、悬疑、耽美等多种类型，满足不同读者的喜好。' } },
      { '@type': 'Question', name: '漫画更新频率如何？', acceptedAnswer: { '@type': 'Answer', text: '我们持续追踪热门漫画的最新连载，确保读者能够第一时间阅读到最新更新的章节，热门作品通常每天都有更新。' } },
      { '@type': 'Question', name: '下拉式阅读是什么意思？', acceptedAnswer: { '@type': 'Answer', text: '下拉式阅读是一种流畅的漫画阅读模式，读者只需向下滑动页面即可连续阅读，无需频繁翻页，带来更加沉浸的阅读体验。' } },
      { '@type': 'Question', name: '需要注册账号才能看漫画吗？', acceptedAnswer: { '@type': 'Answer', text: '不需要，YY漫画网无需注册即可自由浏览和阅读所有漫画内容，真正做到打开即看。' } },
    ],
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = form.querySelector<HTMLInputElement>('input[name="phone_alt"]');
    if (honeypot && honeypot.value.trim() !== '') {
      setFormStatus('success');
      form.reset();
      return;
    }

    try {
      const formData = new FormData(form);
      formData.delete('phone_alt');
      const response = await fetch('https://readdy.ai/api/form/d9ootgosenbniolesj60', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as URLSearchParams).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
        setFormStatus('error');
        setFormError(serverMsg || '提交失败，请稍后重试');
      }
    } catch {
      setFormStatus('error');
      setFormError('网络错误，请稍后重试');
    }
  };

  return (
    <>
      <JsonLd data={aboutJsonLd} />
      <JsonLd data={faqJsonLd} />
      <Navbar />
      <main className="pt-16">
        <section className="bg-background-100 py-12 md:py-20">
          <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
            <h1 className="text-3xl md:text-4xl font-bold text-foreground-950 font-heading">
              关于 YY漫画网
            </h1>
            <p className="text-base text-foreground-500 mt-4 max-w-2xl mx-auto leading-relaxed">
              YY漫画网致力于为广大漫画爱好者提供优质的在线漫画阅读体验
            </p>
          </div>
        </section>

        <section className="py-10 md:py-16 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
              <div>
                <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-4">
                  品牌介绍
                </h2>
                <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
                  <p>
                    YY漫画网是一个专注于提供<strong>免费漫画在线阅读</strong>的综合性漫画平台，汇集了<strong>韩漫</strong>、<strong>日漫</strong>、<strong>国漫</strong>等多个分类的优质漫画资源。
                  </p>
                  <p>
                    我们采用<strong>下拉式漫画阅读</strong>模式，让读者可以流畅地翻阅漫画内容，无需频繁翻页，带来沉浸式的阅读体验。平台持续更新<strong>热门漫画</strong>的最新章节，确保读者能够及时追更喜爱的作品。
                  </p>
                  <p>
                    YY漫画网的<strong>漫画排行榜</strong>基于真实读者评分和浏览量数据，为漫画爱好者提供<strong>好看的漫画推荐</strong>。通过精细的<strong>漫画分类浏览</strong>功能，用户可以轻松找到自己喜欢的类型，无论是热血、恋爱、奇幻还是搞笑，都能在这里找到心仪的作品。
                  </p>
                  <p>
                    我们的使命是让每一位漫画爱好者都能免费、便捷地享受漫画阅读的乐趣，打造中文漫画阅读的优质社区。
                  </p>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8">
                  {[
                    { num: '5000+', label: '漫画资源' },
                    { num: '100万+', label: '日活跃用户' },
                    { num: '99.9%', label: '服务可用率' },
                    { num: '4.9', label: '用户评分' },
                  ].map((stat) => (
                    <div key={stat.label} className="text-center p-4 rounded-lg bg-background-100">
                      <div className="text-xl md:text-2xl font-bold text-accent-500 font-heading">{stat.num}</div>
                      <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="relative">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20cozy%20modern%20reading%20scene%20featuring%20a%20person%20sitting%20comfortably%20on%20a%20sofa%20holding%20a%20tablet%20displaying%20colorful%20manga%20art%20style%20content%20warm%20ambient%20lighting%20bookshelf%20in%20background%20with%20manga%20volumes%20minimalist%20interior%20design%20relaxed%20atmosphere%20soft%20evening%20light&width=800&height=600&seq=about-manga-reading&orientation=landscape"
                  alt="YY漫画网 - 在线漫画阅读体验"
                  className="w-full rounded-lg"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-16 bg-background-100" id="testimonials">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-8 md:mb-10">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
                用户口碑
              </h2>
              <p className="text-sm text-foreground-500 mt-2">来自真实漫画爱好者的评价</p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
              {testimonials.map((t) => (
                <div key={t.id} className="p-5 md:p-6 rounded-lg bg-background-50 border border-background-200">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: t.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    {t.content}
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                      <span className="text-xs font-semibold text-accent-600">{t.name[0]}</span>
                    </div>
                    <span className="text-sm font-medium text-foreground-800">{t.name}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-10 md:py-16 bg-background-50" id="contact">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
              <div>
                <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-4">
                  联系我们
                </h2>
                <p className="text-sm text-foreground-500 leading-relaxed mb-6">
                  如果您有任何问题、建议或合作意向，欢迎通过以下方式联系我们，或填写右侧表单，我们会尽快回复。
                </p>

                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-500 flex-shrink-0">
                      <i className="ri-mail-line"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-800">电子邮箱</h4>
                      <p className="text-sm text-foreground-500">contact@yymanhua.com</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-500 flex-shrink-0">
                      <i className="ri-customer-service-2-line"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-800">客服支持</h4>
                      <p className="text-sm text-foreground-500">工作日 9:00 - 18:00</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-500 flex-shrink-0">
                      <i className="ri-map-pin-line"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-800">公司地址</h4>
                      <p className="text-sm text-foreground-500">中国广州市天河区体育西路123号</p>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <form
                  id="contact-form"
                  data-readdy-form
                  onSubmit={handleSubmit}
                  className="p-5 md:p-6 rounded-lg bg-background-100 border border-background-200"
                >
                  <h3 className="text-lg font-semibold text-foreground-900 mb-4">发送消息</h3>

                  <div className="space-y-4">
                    <div>
                      <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1">姓名</label>
                      <input
                        id="contact-name"
                        name="name"
                        type="text"
                        required
                        className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-accent-500 transition-colors"
                        placeholder="请输入您的姓名"
                      />
                    </div>

                    <div>
                      <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1">邮箱</label>
                      <input
                        id="contact-email"
                        name="email"
                        type="email"
                        required
                        className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-accent-500 transition-colors"
                        placeholder="请输入您的邮箱"
                      />
                    </div>

                    <div>
                      <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-700 mb-1">主题</label>
                      <input
                        id="contact-subject"
                        name="subject"
                        type="text"
                        required
                        className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-accent-500 transition-colors"
                        placeholder="请输入主题"
                      />
                    </div>

                    <div>
                      <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1">消息</label>
                      <textarea
                        id="contact-message"
                        name="message"
                        required
                        maxLength={500}
                        rows={4}
                        className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-accent-500 transition-colors resize-none"
                        placeholder="请输入您的消息（最多500字）"
                      ></textarea>
                    </div>

                    <input
                      type="text"
                      name="phone_alt"
                      tabIndex={-1}
                      autoComplete="off"
                      aria-hidden="true"
                      readOnly
                      className="honeypot-field"
                    />

                    <button
                      type="submit"
                      className="w-full bg-accent-500 hover:bg-accent-600 text-white py-3 rounded-full text-sm font-medium transition-colors whitespace-nowrap"
                    >
                      发送消息
                    </button>
                  </div>

                  {formStatus === 'success' && (
                    <div className="mt-4 p-3 rounded-lg bg-accent-50 text-accent-700 text-sm text-center">
                      消息已发送成功，我们会尽快回复您！
                    </div>
                  )}
                  {formStatus === 'error' && (
                    <div className="mt-4 p-3 rounded-lg bg-red-50 text-red-700 text-sm text-center">
                      {formError}
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-16 bg-background-100" id="faq">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <div className="text-center mb-8">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
                常见问题
              </h2>
            </div>

            <div className="space-y-3">
              {[
                { q: 'YY漫画网的漫画都是免费的吗？', a: '是的，YY漫画网所有漫画内容均为免费阅读，无需付费订阅，让每一位漫画爱好者都能自由畅享阅读乐趣。' },
                { q: '支持哪些类型的漫画？', a: '我们提供韩漫、日漫、国漫等多个分类，涵盖恋爱、热血、奇幻、搞笑、悬疑、耽美等多种类型，满足不同读者的喜好。' },
                { q: '漫画更新频率如何？', a: '我们持续追踪热门漫画的最新连载，确保读者能够第一时间阅读到最新更新的章节，热门作品通常每天都有更新。' },
                { q: '下拉式阅读是什么意思？', a: '下拉式阅读是一种流畅的漫画阅读模式，读者只需向下滑动页面即可连续阅读，无需频繁翻页，带来更加沉浸的阅读体验。' },
                { q: '需要注册账号才能看漫画吗？', a: '不需要，YY漫画网无需注册即可自由浏览和阅读所有漫画内容，真正做到打开即看。' },
              ].map((faq, index) => (
                <details key={index} className="group rounded-lg bg-background-50 border border-background-200">
                  <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                    <h3 className="text-sm font-medium text-foreground-800">{faq.q}</h3>
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}